(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* JSM — bouton « Déjà commandés » : il fonctionne comme Trier / Filtrer,
     sans changer de page. La liste des modèles déjà commandés est rendue
     cachée dans la section ; le bouton bascule entre elle et la grille.
     Le bouton se place lui-même dans la barre Trier / Filtrer (ordinateur)
     ou dans la barre mobile, et se replace après chaque mise à jour. */
  if (!customElements.get('jsm-deja-chip')) {
    customElements.define(
      'jsm-deja-chip',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.product-grid-container') || this.section;
          if (!section) return;
          this.section = section;

          const bouton = this.querySelector('button');
          if (bouton && !bouton.dataset.lie) {
            bouton.dataset.lie = '1';
            bouton.addEventListener('click', () => this.basculer());
          }
          /* Trier / Filtrer pendant le filtre « Déjà commandés » :
             on revient à la collection complète, triée ou filtrée */
          if (!section.dataset.jsmDejaEcoute) {
            section.dataset.jsmDejaEcoute = '1';
            const sortir = (e) => {
              if (!section.classList.contains('jsm-deja-actif')) return;
              if (!e.target.closest('facets-form-component, sorting-filter-component, .facets, .facets--drawer')) return;
              this.basculer(false);
            };
            section.addEventListener('change', sortir, true);
            document.addEventListener('change', (e) => {
              if (e.target.closest && e.target.closest('#filters-drawer')) sortir(e);
            }, true);
          }
          if (!this.mq) {
            this.mq = window.matchMedia('(min-width: 750px)');
            this.mq.addEventListener('change', () => this.placer());
          }
          this.placer();
          this.synchroniser();
          if (window.location.hash === '#deja-commandes' && !section.classList.contains('jsm-deja-actif')) {
            this.basculer(true);
          }
        }

        /* Se place à côté du compteur « N articles », à gauche de la barre :
           les boutons Trier / Filtrer du thème ne sont pas touchés.
           S'il n'est pas affiché (mobile), à côté du bouton Filtrer mobile. */
        placer() {
          const section = this.section;
          const visible = (el) => el && el.getClientRects().length > 0;
          const compte = [...section.querySelectorAll('.products-count-wrapper')].find(visible);
          const cible = compte || section.querySelector('.facets-toggle__wrapper') || section.querySelector('.facets-mobile-wrapper');
          if (!cible) return;
          if (compte) {
            if (this.parentElement !== compte) compte.append(this);
          } else if (this.previousElementSibling !== cible) {
            cible.after(this);
          }
          this.hidden = false;
        }

        basculer(forcer) {
          const section = this.section;
          const actif = forcer === true ? true : forcer === false ? false : !section.classList.contains('jsm-deja-actif');
          section.classList.toggle('jsm-deja-actif', actif);

          /* Cache uniquement le bloc qui contient les cartes de la collection
             (grille + chargement au défilement), rien d'autre dans la barre */
          const wrapper = section.querySelector('.collection-wrapper');
          const carte = wrapper && wrapper.querySelector('[ref="cards[]"]:not(.jsm-deja-grille__item)');
          if (carte) {
            let bloc = carte;
            while (bloc.parentElement && bloc.parentElement !== wrapper) bloc = bloc.parentElement;
            bloc.classList.add('jsm-deja-cache');
          }

          /* Compteur « N articles » de la barre */
          section.querySelectorAll('.products-count-wrapper [role="status"]').forEach((el) => {
            if (!el.dataset.jsmOrigine) el.dataset.jsmOrigine = el.textContent.trim();
            el.textContent = actif ? section.dataset.jsmDejaCompte : el.dataset.jsmOrigine;
          });

          this.synchroniser();

          /* Garde l'état si on recharge la page ou revient en arrière */
          const url = new URL(window.location.href);
          url.hash = actif ? 'deja-commandes' : '';
          history.replaceState(history.state, '', url.toString().replace(/#$/, ''));

          if (forcer === undefined) {
            const haut = section.getBoundingClientRect().top + window.scrollY - 120;
            if (window.scrollY > haut) window.scrollTo({ top: haut, behavior: 'smooth' });
          }
        }

        synchroniser() {
          const actif = this.section && this.section.classList.contains('jsm-deja-actif');
          const bouton = this.querySelector('button');
          if (!bouton) return;
          bouton.setAttribute('aria-pressed', String(!!actif));
          bouton.classList.toggle('is-actif', !!actif);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
